import BaseModel from './BaseModel'
import {currentDate, currentConseillerId} from '@/helpers'

export default class ContactModel extends BaseModel {
  constructor(data: any, relation: any) {
    const fields = {
      ID_CONSEILLER: currentConseillerId(),
      NOM: '',
      DATE_OUVERTURE: currentDate(),
      DATE_PROCHAINE_ACTION: '',
      CODE_REF_STATUT: 'E',
      CODE_REF_SITUATION: null,
      CODE_REF_ORIGINE: null,
      DESCRIPTION_ORIGINE: null,
      NIVEAU_MATURITE: null,
      NIVEAU_ORGANISATION: null,
      NIVEAU_AMBIANCE: null,
      CODE_REF_TYPE_ENTITE: null,
      CODE_REF_TAILLE: null,
      ADRESSE: '',
      CODE_REF_PAYS: 'FRA',
      CODE_REF_DEPARTEMENT: null,
      NOMBRE_LOTS_PRINCIPAUX: '',
      NOMBRE_LOCAUX_COMMERCIAUX: '',
      CODE_REF_PROPORTION_BAILLEURS: null,
      SYNDICAT_SECONDAIRE: null,
      SYNDICAT_COOPERATIF: null,
      MULTI_BATIMENTS: null,
      COMMENTAIRES_IMMEUBLE: '',
      ASCENSEUR: null,
      CHAUFFAGE: null,
      EAU_CHAUDE: null,
      EAU_FROIDE: null,
      ECLAIRAGES_COMMUNS: null,
      LOCAUX_COMMUNS: null,
      ANTENNE_TNT: null,
      FIBRE_OPTIQUE: null,
      ROBINET_PUISAGE: null,
      INTERPHONE: null,
      VIDEO_SURVEILLANCE: null,
      PORTE_MOTORISEE: null,
      BARRIERE_LEVANTE: null,
      PARKINGS: null,
      ESPACES_VERTS: null,
      EMPLOYES: null,
      COMMENTAIRES_EQUIPEMENTS: '',
      DATE_CLOTURE_COMPTES: '',
      DATE_DERNIERE_ASSEMBLEE: '',
      DATE_PROCHAINE_REUNION_CS: '',
      DATE_PROCHAINE_ASSEMBLEE: '',
      PERIODE_PROCHAINE_ASSEMBLEE: '',
      DERNIERS_COMPTES_APPROUVES: null,
      ASSURANCE_IMMEUBLE: null,
      COMPTE_BANCAIRE_SEPARE: null,
      CONSEIL_SYNDICAL_CONSTITUE: null,
      REGLEMENT_COPROPRIETE_A_JOUR: null,
      IMMATRICULATION_A_JOUR: null,
      PROCEDURES_EN_COURS: null,
      IMPAYES: null,
      ARRETE_PERIL: null,
      COORDONNEES_SYNDIC_ACTUEL: '',
      HONORAIRES_SYNDIC_ACTUEL: '',
      BUDGET_ACTUEL: '',
      TRAVAUX_EN_COURS: '',
      TRAVAUX_ENVISAGES: '',
      TRAVAUX_URGENTS_A_REALISER: '',
      COMMENTAIRES_SITUATION: '',
      CODE_REF_TYPE_DEMANDE: null,
      CODE_REF_URGENCE_DEMANDE: null,
      DESCRIPTION_DEMANDE: '',
      DEMARCHE_CONCURRENTS: null,
      DEMARCHE_SYNDICS_PROS: null,
      ADHERENT_ASSOCIATION: null,
      EQUIPE_CONSTITUEE: null,
      COMMENTAIRES_DEMARCHE: '',
      DATE_CLOTURE: null,
      COMMENTAIRES_CLOTURE: '',
      DATE_REPRISE_COMPTABLE: '',
      ENGAGEMENTS_CLIENT: '',
      VRAI_LEAD: null,
      LEAD_CHAUD: null,
      ECHANGE_A_TRAITER: null
    }
    super(data, relation, fields)
  }
}
